export const blockIconsHomeElectricMeter = (
	<span className='material-symbols-outlined'>electric_meter</span>
);
